<button class="back-button" (click)="emitBack()">
  <span class="back-button__icon">
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5.35195 6.6478L10.3839 1.5918L11.2079 2.4158L6.17595 7.4718C5.88795 7.7678 5.88795 8.2398 6.17595 8.5278L11.2079 13.5838L10.3839 14.4078L5.35195 9.3518C4.60795 8.6078 4.60795 7.3998 5.35195 6.6478Z"
        fill="#FF6200"
      />
    </svg>
  </span>
  <div class="back-button__text">voltar</div>
</button>
